// extracted by mini-css-extract-plugin
export default {"cls1":"TagSelector-cls1_aWN","cls2":"TagSelector-cls2_XXk TagSelector-cls1_aWN"};